import { render } from "./social-trading.vue?vue&type=template&id=61aa6332"
import script from "./social-trading.vue?vue&type=script&lang=js"
export * from "./social-trading.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__